import * as actionType from "./withdrawalActionType";

const initialState = {
  isLoading: false,
  isSaved: false,
  withdrawals: []
};

export const withdrawalReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.CREATE_WITHDRAWAL:
            return {
                ...state,
                isLoading: true,
                isSaved: false
            };
        case actionType.CREATE_WITHDRAWAL_FAILURE:
            return {
                ...state,
                isLoading: false,
                isSaved: false
            };
        case actionType.CREATE_WITHDRAWAL_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSaved: true
            };
        case actionType.GET_WITHDRAWALS:
            return {
                ...state,
                isLoading: true
            };
        case actionType.GET_WITHDRAWALS_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.GET_WITHDRAWALS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                withdrawals: action.payload ? action.payload : []
            };
        default:
            return state;
    }
}
